import { useContext } from 'react'
import { IngredientsRefContext, type IngredientsRefContextValue } from './IngredientsRefContext'

export function useIngredientsRef(): IngredientsRefContextValue {
  const context = useContext(IngredientsRefContext)
  if (!context) {
    throw new Error('useIngredientsRef must be used within an IngredientsRefProvider')
  }
  return context
}
